import AuthService from "../login/auth.service";
import { solicitudes } from "../../components/generico/utils/UrlAPI";

import { notificaciones } from "../../components/generico/utils/UrlAPI";
import { alertas } from "../../components/generico/utils/UrlAPI";import axios from "axios";

class SolicitudesService {

  async getTiposTarjetas() {

    var config = {
      method: "get",
      url: solicitudes + "solicitudes/tarjetas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };

    return await axios(config);
  }


  async confirmarSolicitudTC(monto, tipo, telefono, email) {
    var usuario = AuthService.getSocio();

    var data = JSON.stringify({
      numeroSocio: usuario.numeroSocio,
      monto: monto,
      marcaTarjeta: tipo,
      tipoServicio: "T",
      canalCarga: "W",
      estado: "P",
      telContactoCel: telefono,
      email: email,
    });

    var config = {
      method: "post",
      url: solicitudes + "solicitudes/tarjetas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }



  async getTarjetasSocios() {
    // var usuario = AuthService.getSocio();

    var config = {
      method: "get",
      url: solicitudes + "solicitudes/tarjetas/por-socio?canal=WEB",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };

    return await axios(config);
  }

  async confirmarSolicitudAumentoTC(monto, tipo, telefono, email, numeroTC) {
    var usuario = AuthService.getSocio();

    var data = JSON.stringify({
      numeroSocio: usuario.numeroSocio,
      monto: monto,
      numeroTarjeta: numeroTC,
      marcaTarjeta: tipo,
      tipoServicio: "A",
      canalCarga: "W",
      estado: "P",
      telContactoCel: telefono,
      email: email,
    });

    var config = {
      method: "post",
      url: solicitudes + "solicitudes/tarjetas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }


  /** 
   * Alertas
  */
  async getAlertasDisponibles() {
    var data = JSON.stringify({
      canal: "WEB",

    });

    var config = {
      method: "post",
      url: notificaciones + "alertas/obtener-suscripcion",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }

  async getAlertasTarjetas(telefono) {
    var data = JSON.stringify({
      canal: "WEB",
      nroAlerta: "5",
      nroTelefono: telefono,
      modo: "S",
      ctaDebito: null,
      total: null,
      suscripciones: []

    });

    var config = {
      method: "post",
      url: notificaciones + "alertas/suscripciones",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)

    return await axios(config);
  }


  async confirmarAlertas(nroAlerta, telefono,crearNroTelefono, saldo, suscripciones) {
    var data = JSON.stringify({
      canal: "WEB",
      nroAlerta: nroAlerta,
      nroTelefono: telefono,
      crearNroTelefono:crearNroTelefono,
      modo: "C",
      cuentadebito: "0",
      ctaDebito: null,
      total: saldo,
      suscripciones: suscripciones,

    });

    var config = {
      method: "post",
      url: notificaciones+"alertas/suscripciones",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }
  async confirmarCambioNumero(telefono) {
  
    var data = JSON.stringify({
     
     
      telefono: telefono,
     
    });

    var config = {
      method: "post",
      url: notificaciones +"alertas/actualizar-numero-telefono",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }
  async activarDesactivarAlertas(tipo,numero,estado) {
  
    var data = JSON.stringify({
     
     
      estado: estado,
      tipo:tipo,
      numero:numero
     
    });

    var config = {
      method: "post",
      url: notificaciones + "alertas/cambiar-estado-alerta",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }
  async obtenerListadoAlertas() {
    var data = JSON.stringify({
      canal: "WEB",

    });

    var config = {
      method: "get",
      url: notificaciones + "alertas/obtener-suscripcion-socio",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
     
    };

    return await axios(config);
  }

  async obtenerListadoAlertasTarjetas() {
    var data = JSON.stringify({
      canal: "WEB",

    });

    var config = {
      method: "get",
      url: notificaciones + "alertas/obtener-suscripcion-tarjeta",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
     
    };

    return await axios(config);
  }
  async SuscripcionTarjeta(numTarjeta) {
  
    var data = JSON.stringify({
     
      numeroCuenta: numTarjeta,
     
    });

    var config = {
      method: "post",
      url: notificaciones + "alertas/alta-suscripcion-tarjeta",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }
  async actualizarEstadoAdicional(numeroCuenta,adicional) {
  
    var data = JSON.stringify({
      
      numeroCuenta: numeroCuenta,
      adicional:adicional
     
    });

    var config = {
      method: "post",
      url: notificaciones + "alertas/actualizar-estado-adicional",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //console.log(data)
    return await axios(config);
  }

}
export default new SolicitudesService();